<app-records-table-view
  class="records-table-view"
  [resourceParams]="getResourceParams(resourceParamsKey())"
  [tableColumnsParams]="columnsParams"
  [tableData]="tableData()"
  [tableActions]="[]"
  [tableTotals]="[]"
/>
